export default {
  state: {
    toasts: [],
    modal: false
  },

  actions: {
    notificationCreateToast({ commit }, toast) {
      toast.id = Math.random()
        .toString(36)
        .substr(2);
      commit('NOTIFICATION_PUSH_TOAST', toast);
      setTimeout(() => {
        commit('NOTIFICATION_REMOVE_TOAST', toast);
      }, toast.delay || 3000);
    },
    notificationCreateModal({ commit }, payload) {
      commit('NOTIFICATION_SHOW_MODAL', payload);
    }
  },

  mutations: {
    NOTIFICATION_PUSH_TOAST(state, toast) {
      state.toasts.push(toast);
    },
    NOTIFICATION_REMOVE_TOAST(state, toast) {
      const arrayIndex = state.toasts.findIndex(t => toast.id === t.id);
      if (arrayIndex >= 0) state.toasts.splice(arrayIndex, 1);
    },
    NOTIFICATION_SHOW_MODAL(state, modal) {
      state.modal = modal;
    },
    NOTIFICATION_REMOVE_MODAL(state) {
      state.modal = false;
    }
  }
};
